<template>
    <div class="clearfix">
        <span class="go-index" @click="gotoPage()">返回</span>
        <ul>
            <!-- <div class="my-head"></div> -->
            <li>
                <img :src='userInfo.head' style="width: 10rem; height: 10rem; border-radius: 5rem; display:block;margin: 1rem auto;">
                <div style="text-align: center;" v-if="userInfo.head_id_tmp != 0 ">(审核中)</div>
                <button @click="fileImage" style="border: 0px none; padding:0.5rem 0; border-radius: 0.5rem; margin: 2rem auto;width: 10rem;display:block; color: #FFFFFF; background: rgba(255,96,96,1);">上传照片</button>
                <input ref="fileImage" style="display: none;" class="upload" @change="addImage" type="file" />
            </li>

            <p style="padding: 0 0.5rem;font-size: 0.8rem;">照片建议：</p>
            <p style="padding: 0 0.5rem;font-size: 0.8rem;text-indent:1.6rem;">可使用正面、侧面、背面等生活照(可使用表情遮盖关键部位)，禁止使用他人照片或商业素材。如有法律争议，责任自负!</p>
            <hr style="color: blue; border: 0px; border-bottom: 1px solid #5c5c3d;">

            <!-- 列表 -->
            <li v-for="(item,index) in images" :key="index" style="text-align: center;" >
                <img :src='item.image_link' style="border-radius: 0.5rem; height: 10rem;display:block;margin: 1rem auto;">
                <br />
                <button v-if="item.is_head == 1" style="border: 0px none; margin: 1rem auto; padding:0.5rem 0.5rem; border-radius: 0.2rem;">(当前头像)</button>
                <button v-if="item.is_tmp == 1" style="border: 0px none; margin: 1rem auto; padding:0.5rem 0.5rem; border-radius: 0.2rem;">(审核中)</button>
                <button @click="addHead(item.image_id)" v-if="item.is_head == 0 && item.is_tmp == 0 " style="display:inline-block;border: 0px none; margin: 1rem 0.5rem; padding:0.2rem 0.5rem; border-radius: 0.5rem;color: #FFFFFF; background: rgba(255,96,96,1);">设为头像</button>
                <button @click="delImage(item.image_id)" v-if="item.is_head == 0 && item.is_tmp == 0 " style="display:inline-block;border: 0px none; margin: 1rem 0.5rem; padding:0.2rem 0.5rem; border-radius: 0.5rem;">删除</button>
            </li>

            <br><br><br>
            
        </ul>
        <!-- 组件使用 -->
        <syalert ref="syalert_id" />
    </div>
</template>
<script>

    import sy from "@/sy";

    // 组件引入
    import syalert from '@/components/syalert.vue';

    // 上传截图
    // http://www.baidu.com/s?ie=UTF-8&wd=vue+%E4%B8%8A%E4%BC%A0+%E6%88%AA%E5%9B%BE
    // https://www.cnblogs.com/-youth/p/12935685.html

export default {
    name: "images",
    components:{
        // top,
        // user,
        // foot,
        syalert,
    },
    data() {
        return {
            imgs: [],
            imgData: {
                accept: 'image/jpeg, image/jpg'//, image/png
            },
            userInfo: {
                head: ''
            },
            images: [],
        };
    },
    methods: {
            gotoPage:function(page)
            {
                if( page !== undefined )
                {
                    this.$router.push(page);
                }else{
                    this.$router.go(-1);
                }
            },
        fileImage: function()
        {
            this.$refs.fileImage.dispatchEvent(new MouseEvent('click')) 
        },
        getHead: function()
        {
            let $_this = this;
            sy.http.get({
                url: this.$root.API + 'UserImage/GetHead',
                data: {},
                success: function(res)
                {
                    $_this.userInfo = res.data;
                }
            });
        },
        addHead: function(image_id)
        { 
            let $_this = this;
            sy.http.get({
                url: this.$root.API + 'UserImage/AddHead',
                data: 
                {
                    image_id: image_id,
                },
                success: function(res)
                {
                    $_this.$refs.syalert_id.syalert(res.msg);
                    setTimeout(function ()
                    {
                        if( res.state === '1' )
                        {
                            $_this.getHead();
                            $_this.getImage();
                        }
                    }, 1000);             
                }
            });
        },
        getImage: function()
        {
            let $_this = this;
            sy.http.get(
            {
                url: this.$root.API + 'UserImage/GetImage',
                success: function(res)
                {
                    $_this.images = res.data;
                }
            });
        },
        delImage: function( image_id )
        {
            let con = confirm("确定删除?");
            if (con !== true) {
                return false;
            }
            
            let $_this = this;
            sy.http.get(
            {
                url: this.$root.API + 'UserImage/DelImage' + '?image_id=' + image_id,
                success: function(res)
                {
                    $_this.$refs.syalert_id.syalert(res.msg);
                    $_this.getImage();
                }
            });
        },
        addImage: function(event)
        {
            let ishead = this.$router.currentRoute.query.ishead;
            if( ishead === undefined )
            {
                ishead = 0;
            }
            
            //let reader =new FileReader();
            let img1 = event.target.files[0];
            let type = img1.type; //文件的类型，判断是否是图片
            let size = img1.size; //文件的大小，判断图片的大小
            if (this.imgData.accept.indexOf(type) == -1) {
                alert('请选择我们支持的图片格式！:jpeg或jpg');
                return false;
            }
            if (size > 1024 * 1024 * 6) {
                alert('请选择6M以内的图片！'); // 3145728 = 1024 * 1024 * 3
                return false;
            }
            this.$refs.syalert_id.syalert('正在上传,请稍等');
            
            let $_this = this;
            let data = 
            {
                "file": event.target.files[0],
                "url": this.$root.API + "UserImage/AddImage",
                "data": 
                {
                    utoken: localStorage.getItem("utoken"),
                    ishead: ishead,
                }
            }
            sy.filechunk.progress = function(res)
            {
                // $_this.userInfo.head = res.data.link;
                if( res.state === '0' || res.state === '1' )
                {
                    $_this.$refs.syalert_id.syalert(res.msg);
                }
                $_this.getHead();
                $_this.getImage();
            }
            sy.filechunk.init( data );

        },
        checkImage: function()
        {
            // 未使用到 本来要做归纳整理上面的 照片前置检查
        },
    },
    mounted() {
        this.getHead();
        this.getImage();
    },
};
</script>
<style>
    .upload {
        width: 40%;
        margin: 2rem auto;
        text-align: center;
    }
</style>
